function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.7187 35.6817H4.35304C3.97791 35.6805 3.60958 35.5815 3.28442 35.3944C2.95926 35.2073 2.6885 34.9387 2.49888 34.615C2.30855 34.2906 2.2077 33.9216 2.20661 33.5455C2.20553 33.1695 2.30426 32.7998 2.49272 32.4744L18.6853 4.45359C18.8721 4.1284 19.1415 3.8583 19.4661 3.67063C19.7908 3.48296 20.1593 3.38437 20.5343 3.38483C21.2971 3.38483 22.0076 3.79447 22.3875 4.45462L38.5359 32.4046C38.7383 32.7289 38.8503 33.1015 38.8602 33.4837C38.87 33.8659 38.7775 34.2438 38.5921 34.5781C38.4067 34.9125 38.1352 35.1911 37.8058 35.3852C37.4764 35.5792 37.101 35.6816 36.7187 35.6817ZM20.4799 5.48026H20.4625L4.27296 33.497L4.35304 33.6294H36.7187C36.7639 33.6294 36.808 33.5853 36.808 33.5411C36.8008 33.5298 36.7649 33.4425 36.7577 33.4313L20.6083 5.48026H20.4799Z",
  fill: "#3C50E0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5364 14.9637V23.8967C19.549 24.1973 19.6773 24.4814 19.8944 24.6896C20.1116 24.8978 20.4008 25.0141 20.7016 25.0141C21.0025 25.0141 21.2917 24.8978 21.5089 24.6896C21.726 24.4814 21.8543 24.1973 21.8669 23.8967V14.9637C21.8666 14.6543 21.7439 14.3577 21.5256 14.1386C21.3072 13.9194 21.011 13.7957 20.7016 13.7943C20.062 13.7943 19.5364 14.321 19.5364 14.9637Z",
  fill: "#3C50E0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7027 26.6163C20.0621 26.6163 19.5374 27.1358 19.5374 27.7785V28.5598C19.5396 28.8679 19.6632 29.1627 19.8813 29.3803C20.0995 29.5978 20.3946 29.7206 20.7027 29.7219C21.3454 29.7219 21.868 29.1953 21.868 28.5598V27.7785C21.868 27.1358 21.3444 26.6163 20.7027 26.6163Z",
  fill: "#3C50E0"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 35.2,
  cy: 32.2,
  r: 8.8,
  fill: "#FAB100"
});

var SvgAlert = function SvgAlert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert.bb522f8a.svg";
export { ForwardRef as ReactComponent };